import { frontEndUserConstants } from "../constant/front-end-constant";

const initialState = {
    testimonails: {
        data: []
    }
}

export default (state = initialState, action) => {
    switch (action.type) {

        case frontEndUserConstants.GET_ALL_TESTIMONIALS_SUCCESS:
            return {
                ...state,
                testimonails: action.payload.data.pagination, 
                pages: action.payload.data.pagination.last_page, 
                current_page: action.payload.data.pagination.current_page, 
                perPage: action.payload.data.pagination.per_page
            }
        case frontEndUserConstants.GET_ALL_TESTIMONIALS_FAILURE:
            return {
                ...state,
                error: action.payload
            }
        case frontEndUserConstants.STORE_TESTIMONAIL_FAILURE:
            return {
                ...state,
                error: action.payload
            }
        default:
            return state
    }
}
